/* GK — carrinho: topo que encolhe, confetes ao subir de promoção, cupão, "Combina com a tua compra" e "Continuar a comprar" */
(function () {
  if (window.__gkCartX) return;
  window.__gkCartX = true;

  const mem = {};
  const store = {
    get(k) {
      try { const v = sessionStorage.getItem(k); return v === null ? null : v; } catch (e) { return k in mem ? mem[k] : null; }
    },
    set(k, v) {
      try { sessionStorage.setItem(k, String(v)); } catch (e) { mem[k] = String(v); }
    },
  };

  const drawerEl = () => document.querySelector('cart-drawer');
  const sectionsUrl = () => window.location.pathname;

  /* ---------- Re-desenhar o carrinho com a resposta da Shopify ---------- */
  function renderDrawer(state) {
    const drawer = drawerEl();
    if (!drawer || !state || !state.sections) {
      window.location.reload();
      return;
    }
    drawer.classList.toggle('is-empty', state.item_count === 0);
    if (typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json().then((j) => ({ ok: r.ok, json: j })));
  }

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  /* ---------- Ligações ao carrinho do tema (sem mexer nos ficheiros originais) ---------- */
  customElements.whenDefined('cart-drawer').then(() => {
    const C = customElements.get('cart-drawer');
    if (!C || C.prototype.__gkPatched) return;
    C.prototype.__gkPatched = true;
    const open = C.prototype.open;
    const close = C.prototype.close;
    C.prototype.open = function () {
      document.body.classList.add('gk-cart-open');
      const r = open.apply(this, arguments);
      window.dispatchEvent(new CustomEvent('gk:cart-open'));
      return r;
    };
    const renderContents = C.prototype.renderContents;
    if (renderContents) {
      C.prototype.renderContents = function () {
        window.__gkcRenderedAt = Date.now();
        return renderContents.apply(this, arguments);
      };
    }
    C.prototype.close = function () {
      document.body.classList.remove('gk-cart-open');
      return close.apply(this, arguments);
    };
  });

  // Quando algo é adicionado fora do carrinho, atualiza o carrinho inteiro (incluindo o topo das metas)
  customElements.whenDefined('cart-drawer-items').then(() => {
    const C = customElements.get('cart-drawer-items');
    if (!C || C.prototype.__gkPatched) return;
    C.prototype.__gkPatched = true;
    C.prototype.onCartUpdate = function () {
      // O carrinho acabou de ser desenhado com a resposta da Shopify: não é preciso pedi-lo outra vez
      if (window.__gkcRenderedAt && Date.now() - window.__gkcRenderedAt < 2500) return Promise.resolve();
      const url = (window.routes && window.routes.cart_url) || '/cart';
      return fetch(`${url}?section_id=cart-drawer`)
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const src = html.querySelector('.drawer__inner');
          const target = document.querySelector('#CartDrawer .drawer__inner');
          if (!src || !target) return;
          target.innerHTML = src.innerHTML;
          const srcDrawer = html.querySelector('cart-drawer');
          const drawer = drawerEl();
          if (srcDrawer && drawer) drawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
        })
        .catch((e) => console.error(e));
    };
  });

  /* ---------- Ao mudar a quantidade ou remover, a lista fica onde estava (não salta para o topo) ---------- */
  let gkcKeep = null;
  const rememberScroll = (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('#CartDrawer .gk-mini-qty, #CartDrawer cart-remove-button')) return;
    const list = document.querySelector('#CartDrawer cart-drawer-items');
    if (list) gkcKeep = { el: list, y: list.scrollTop, t: Date.now() };
  };
  document.addEventListener('click', rememberScroll, true);
  document.addEventListener('change', rememberScroll, true);
  const watchDrawer = () => {
    const root = document.getElementById('CartDrawer');
    if (!root || !('MutationObserver' in window)) return;
    new MutationObserver(() => {
      if (!gkcKeep) return;
      if (Date.now() - gkcKeep.t > 10000) { gkcKeep = null; return; }
      const list = root.querySelector('cart-drawer-items');
      if (!list || list === gkcKeep.el) return;
      const y = gkcKeep.y;
      gkcKeep = null;
      requestAnimationFrame(() => { list.scrollTop = y; });
    }).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();

  /* ---------- Continuar a comprar: volta à página onde o cliente estava a ver produtos ---------- */
  const isBrowsePage = (path) =>
    path === '/' || path === '' || ((/^\/collections(\/|$)/.test(path) || /^\/search/.test(path)) && !/\/products\//.test(path));
  const here = window.location.pathname;
  if (isBrowsePage(here)) {
    const url = here + window.location.search;
    const save = () => store.set('gkc_back', JSON.stringify({ url, y: Math.round(window.scrollY) }));
    save();
    window.addEventListener('pagehide', save);
    document.addEventListener('visibilitychange', () => document.visibilityState === 'hidden' && save());
    document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('a[href*="/products/"]')) save(); }, true);

    let restore = null;
    try { restore = JSON.parse(store.get('gkc_restore') || 'null'); } catch (e) {}
    if (restore && restore.url === url) {
      store.set('gkc_restore', 'null');
      const go = () => window.scrollTo(0, restore.y || 0);
      window.addEventListener('load', () => setTimeout(go, 50), { once: true });
      setTimeout(go, 400);
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-gkc-continue]');
    if (!btn) return;
    e.preventDefault();
    const drawer = drawerEl();
    if (isBrowsePage(window.location.pathname)) {
      if (drawer) drawer.close();
      return;
    }
    let back = null;
    try { back = JSON.parse(store.get('gkc_back') || 'null'); } catch (e2) {}
    if (!back || !back.url) {
      try {
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.origin === window.location.origin && isBrowsePage(ref.pathname)) back = { url: ref.pathname + ref.search, y: 0 };
      } catch (e3) {}
    }
    const target = back && back.url ? back.url : '/';
    store.set('gkc_restore', JSON.stringify({ url: target, y: (back && back.y) || 0 }));
    window.location.href = target;
  });

  /* ---------- Dinheiro ---------- */
  function money(cents, format) {
    const fmt = format || '€{{amount_with_comma_separator}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const intDots = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const intCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_with_comma_separator': return intDots + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return intDots;
        case 'amount_no_decimals': return intCommas;
        default: return intCommas + '.' + dec;
      }
    });
  }

  /* ---------- Topo: encolher ao descer, crescer ao subir ---------- */
  document.addEventListener(
    'scroll',
    (e) => {
      const el = e.target;
      if (!el || el.tagName !== 'CART-DRAWER-ITEMS') return;
      const top = el.closest('.drawer__inner') && el.closest('.drawer__inner').querySelector('gk-cart-top');
      if (!top) return;
      const room = el.scrollHeight - el.clientHeight;
      if (!top.classList.contains('is-compact')) {
        if (el.scrollTop > 48 && room > 140) top.classList.add('is-compact');
      } else if (el.scrollTop < 8) {
        top.classList.remove('is-compact');
      }
    },
    true
  );

  /* ---------- Confetes azuis ---------- */
  function confetti(host) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const canvas = document.createElement('canvas');
    canvas.className = 'gkc-confetti';
    host.appendChild(canvas);
    const rect = host.getBoundingClientRect();
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    const colors = ['#1d5cff', '#4f7dff', '#00b3ff', '#7cc4ff', '#0b3bcc', '#bcd3ff', '#ffffff', '#ffc400'];
    const W = rect.width;
    const H = rect.height;
    const parts = [];
    const n = W < 500 ? 130 : 170;
    for (let i = 0; i < n; i++) {
      const fromLeft = i % 2 === 0;
      parts.push({
        x: fromLeft ? W * 0.15 : W * 0.85,
        y: H * 0.22,
        vx: (fromLeft ? 1 : -1) * (2 + Math.random() * 6) + (Math.random() - 0.5) * 3,
        vy: -(5 + Math.random() * 8),
        w: 5 + Math.random() * 6,
        h: 3 + Math.random() * 5,
        r: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.35,
        c: colors[(Math.random() * colors.length) | 0],
        round: Math.random() < 0.35,
      });
    }
    const start = performance.now();
    const DURATION = 2600;
    function frame(now) {
      const t = now - start;
      ctx.clearRect(0, 0, W, H);
      const fade = t > DURATION - 700 ? Math.max(0, (DURATION - t) / 700) : 1;
      for (const p of parts) {
        p.vy += 0.22;
        p.vx *= 0.985;
        p.vy *= 0.985;
        p.x += p.vx;
        p.y += p.vy;
        p.r += p.vr;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.r);
        ctx.fillStyle = p.c;
        if (p.c === '#ffffff') {
          ctx.strokeStyle = '#bcd3ff';
          ctx.lineWidth = 0.6;
        }
        if (p.round) {
          ctx.beginPath();
          ctx.arc(0, 0, p.h * 0.7, 0, Math.PI * 2);
          ctx.fill();
          if (p.c === '#ffffff') ctx.stroke();
        } else {
          ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h * Math.abs(Math.cos(p.r * 2)) + 1);
        }
        ctx.restore();
      }
      if (t < DURATION) requestAnimationFrame(frame);
      else canvas.remove();
    }
    requestAnimationFrame(frame);
  }

  function whenDrawerOpen(cb) {
    let tries = 0;
    const check = () => {
      const d = drawerEl();
      if (d && d.classList.contains('active')) return setTimeout(cb, 260);
      if (++tries < 30) setTimeout(check, 100);
    };
    check();
  }

  if (!customElements.get('gk-cart-top')) {
    customElements.define(
      'gk-cart-top',
      class extends HTMLElement {
        connectedCallback() {
          const tier = parseInt(this.dataset.tier || '0', 10);
          const count = parseInt(this.dataset.count || '0', 10);
          const prevTier = store.get('gkc_tier');
          const prevCount = store.get('gkc_count');

          if (prevCount !== null && parseInt(prevCount, 10) !== count) {
            this.classList.add('is-growing');
            setTimeout(() => this.classList.remove('is-growing'), 1200);
          }

          if (prevTier !== null && tier > parseInt(prevTier, 10)) {
            whenDrawerOpen(() => {
              const top = this.isConnected ? this : document.querySelector('#CartDrawer gk-cart-top');
              if (!top) return;
              top.classList.add('is-celebrating');
              const host = top.closest('.drawer__inner') || top;
              confetti(host);
              setTimeout(() => {
                const now = document.querySelector('#CartDrawer gk-cart-top');
                if (now) now.classList.remove('is-celebrating');
                top.classList.remove('is-celebrating');
              }, 2000);
            });
          }
          store.set('gkc_tier', tier);
          store.set('gkc_count', count);
        }
      }
    );
  }

  const initTier = () => {
    if (!document.querySelector('gk-cart-top') && store.get('gkc_tier') === null) {
      store.set('gkc_tier', 0);
      store.set('gkc_count', 0);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTier);
  else initTier();

  /* ---------- Cupão ---------- */
  if (!customElements.get('gk-cart-coupon')) {
    customElements.define(
      'gk-cart-coupon',
      class extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-gkc-toggle]');
          this.form = this.querySelector('[data-gkc-form]');
          this.msg = this.querySelector('[data-gkc-msg]');
          this.removeBtn = this.querySelector('[data-gkc-remove]');

          if (this.toggle) {
            this.toggle.addEventListener('click', () => {
              const open = this.form.hidden;
              this.form.hidden = !open;
              this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
              this.classList.toggle('is-open', open);
              if (open) this.form.querySelector('input').focus();
            });
          }
          if (this.form) {
            this.form.addEventListener('submit', (e) => {
              e.preventDefault();
              const code = (this.form.querySelector('input').value || '').trim();
              if (!code) {
                this.showMsg('Escreve o código do cupão.', true);
                return;
              }
              this.apply(code);
            });
          }
          if (this.removeBtn) {
            this.removeBtn.addEventListener('click', () => this.remove());
          }

          const pending = window.__gkcPending;
          if (pending) {
            window.__gkcPending = null;
            if (pending.error && this.form) {
              this.form.hidden = false;
              this.classList.add('is-open');
              if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
              this.form.querySelector('input').value = pending.code || '';
            }
            this.showMsg(pending.text, pending.error);
          }
        }

        showMsg(text, isError) {
          if (!this.msg) return;
          this.msg.textContent = text;
          this.msg.hidden = !text;
          this.msg.classList.toggle('is-error', !!isError);
        }

        busy(on) {
          this.classList.toggle('is-busy', on);
          this.querySelectorAll('button, input').forEach((el) => (el.disabled = on));
        }

        apply(code) {
          const previous = this.dataset.applied || '';
          this.busy(true);
          this.showMsg('', false);
          postJSON('/cart/update.js', { discount: code, sections: SECTIONS, sections_url: sectionsUrl() })
            .then(({ ok, json }) => {
              const codes = (json && json.discount_codes) || [];
              const hit = codes.find((c) => (c.code || '').toUpperCase() === code.toUpperCase());
              if (ok && hit && hit.applicable) {
                window.__gkcPending = { text: '', error: false };
                renderDrawer(json);
                return;
              }
              return postJSON('/cart/update.js', { discount: previous, sections: SECTIONS, sections_url: sectionsUrl() }).then(
                (res) => {
                  window.__gkcPending = {
                    text: 'Este código não é válido ou não se aplica a este carrinho.',
                    error: true,
                    code: code,
                  };
                  renderDrawer(res.json);
                }
              );
            })
            .catch(() => {
              this.busy(false);
              this.showMsg('Não foi possível aplicar o cupão. Tenta outra vez.', true);
            });
        }

        remove() {
          this.busy(true);
          postJSON('/cart/update.js', { discount: '', sections: SECTIONS, sections_url: sectionsUrl() })
            .then(({ json }) => renderDrawer(json))
            .catch(() => this.busy(false));
        }
      }
    );
  }

  /* ---------- Combina com a tua compra ---------- */
  const UP_TTL = 15 * 60 * 1000;

  if (!customElements.get('gk-cart-upsell')) {
    customElements.define(
      'gk-cart-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.gkc-up__list');
          this.exclude = (this.dataset.exclude || '').split(',').map((n) => parseInt(n, 10));
          this.format = this.dataset.moneyFormat;
          const pid = this.dataset.productId;
          if (!pid) return;

          this.querySelectorAll('[data-gkc-arrow]').forEach((b) =>
            b.addEventListener('click', () => {
              const card = this.list.querySelector('.gkc-up__card');
              const step = card ? card.getBoundingClientRect().width + 8 : 220;
              this.list.scrollBy({ left: step * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
            })
          );
          this.list.addEventListener('scroll', () => this.arrows(), { passive: true });

          // Só vai buscar sugestões quando o carrinho está aberto (não pesa no carregamento das páginas)
          const drawer = this.closest('cart-drawer');
          if (drawer && !drawer.classList.contains('active')) {
            const go = () => { if (this.isConnected) this.load(pid); };
            window.addEventListener('gk:cart-open', go, { once: true });
            return;
          }
          this.load(pid);
        }

        load(pid) {
          if (this.__loaded) return;
          this.__loaded = true;
          const key = 'gkc_up_' + pid;
          let cached = null;
          try { cached = JSON.parse(store.get(key) || 'null'); } catch (e) {}
          if (cached && Date.now() - cached.t < UP_TTL) {
            this.render(cached.p);
            return;
          }
          const base = this.dataset.url || '/recommendations/products';
          fetch(`${base}.json?product_id=${pid}&limit=10`, { credentials: 'same-origin' })
            .then((r) => (r.ok ? r.json() : { products: [] }))
            .then((data) => {
              const slim = (data.products || []).map((p) => ({
                id: p.id,
                title: p.title,
                url: p.url,
                price: p.price,
                compare: p.compare_at_price,
                img: p.featured_image,
                variants: (p.variants || []).map((v) => ({ id: v.id, o: v.option1, a: v.available, p: v.price })),
              }));
              store.set(key, JSON.stringify({ t: Date.now(), p: slim }));
              if (this.isConnected) this.render(slim);
            })
            .catch(() => {});
        }

        render(products) {
          const list = products
            .filter((p) => !this.exclude.includes(p.id))
            .filter((p) => p.price > 0 && !/badge|patch/i.test(p.title))
            .filter((p) => p.variants.some((v) => v.a))
            .slice(0, 8);
          if (!list.length) return;
          this.items = list;
          this.list.innerHTML = list
            .map((p, i) => {
              const img = p.img ? p.img + (p.img.includes('?') ? '&' : '?') + 'width=160' : '';
              const compare = p.compare && p.compare > p.price ? `<s>${money(p.compare, this.format)}</s>` : '';
              return `<li class="gkc-up__card" data-i="${i}">
                <a class="gkc-up__img" href="${p.url}" tabindex="-1" aria-hidden="true">${img ? `<img src="${img}" alt="" loading="lazy" width="80" height="80">` : ''}</a>
                <div class="gkc-up__info">
                  <a class="gkc-up__name" href="${p.url}">${escapeHtml(p.title)}</a>
                  <div class="gkc-up__price"><span>${money(p.price, this.format)}</span>${compare}</div>
                  <div class="gkc-up__sizes" hidden></div>
                </div>
                <button type="button" class="gkc-up__add" aria-label="Adicionar ${escapeHtml(p.title)}">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
                </button>
              </li>`;
            })
            .join('');
          this.hidden = false;
          requestAnimationFrame(() => this.arrows());
          this.list.querySelectorAll('.gkc-up__card').forEach((card) => {
            card.querySelector('.gkc-up__add').addEventListener('click', () => this.choose(card));
          });
        }

        arrows() {
          const l = this.list;
          const prev = this.querySelector('[data-gkc-arrow][data-dir="-1"]');
          const next = this.querySelector('[data-gkc-arrow][data-dir="1"]');
          if (!prev || !next) return;
          const max = l.scrollWidth - l.clientWidth - 2;
          prev.classList.toggle('is-off', l.scrollLeft <= 2);
          next.classList.toggle('is-off', l.scrollLeft >= max);
        }

        choose(card) {
          const p = this.items[parseInt(card.dataset.i, 10)];
          const avail = p.variants.filter((v) => v.a);
          const onlyOne = p.variants.length === 1 || avail.every((v) => v.o === avail[0].o);
          if (onlyOne) return this.add(card, avail[0].id);

          const box = card.querySelector('.gkc-up__sizes');
          if (!box.hidden) {
            box.hidden = true;
            card.classList.remove('is-choosing');
            return;
          }
          const seen = new Set();
          const chips = [];
          p.variants.forEach((v) => {
            if (seen.has(v.o)) return;
            seen.add(v.o);
            const first = p.variants.find((x) => x.o === v.o && x.a);
            chips.push(
              `<button type="button" class="gkc-up__size" ${first ? `data-id="${first.id}"` : 'disabled'}>${escapeHtml(v.o || '')}</button>`
            );
          });
          box.innerHTML = chips.join('');
          box.hidden = false;
          card.classList.add('is-choosing');
          box.querySelectorAll('[data-id]').forEach((b) =>
            b.addEventListener('click', () => this.add(card, parseInt(b.dataset.id, 10)))
          );
        }

        add(card, variantId) {
          card.classList.add('is-busy');
          postJSON('/cart/add.js', {
            items: [{ id: variantId, quantity: 1 }],
            sections: SECTIONS,
            sections_url: sectionsUrl(),
          })
            .then(({ ok, json }) => {
              if (!ok) throw new Error(json && json.description);
              renderDrawer(json);
            })
            .catch(() => {
              card.classList.remove('is-busy');
              card.classList.add('is-error');
              setTimeout(() => card.classList.remove('is-error'), 1500);
            });
        }
      }
    );
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
})();
